import React from 'react';
import { STRIPE_PUBLIC_KEY } from 'constants/stripe';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import Content from './Content';

const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

export default function Wrapper() {
    return (
        <Elements stripe={stripePromise}>
            <Content />
        </Elements>
    );
}
